<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import FeaturedProject from '@/views/home/FeaturedProject.vue';
import { getFeaturedProjects, type GetFeaturedProjectsProjectResponse } from '@/api';
import SectionHeader from '@/components/SectionHeader.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const fetchFeaturedProjects = async (): Promise<GetFeaturedProjectsProjectResponse[]> => {
  const fetch = await getFeaturedProjects();
  if (fetch.response?.ok && fetch.data) {
    return fetch.data.items.shuffle();
  } else {
    throw Error(`Fetching search results failed: ${fetch.error}`);
  }
};

const featuredProjects = ref<GetFeaturedProjectsProjectResponse[]>([]);

const loadFeaturedProjects = async () => {
  try {
    featuredProjects.value = await fetchFeaturedProjects();
  } catch (err) {
    console.error(err);
  }
};

onMounted(() => {
  loadFeaturedProjects();
});
</script>

<template>
  <section v-if="featuredProjects.length > 0" class="mb-6">
    <SectionHeader class="mb-2!">{{ t('views.home.featured.header') }}</SectionHeader>
    <ul class="grid grid-cols-12 gap-2 divide-y divide-gray-900/10" role="list">
      <FeaturedProject v-for="(project, index) in featuredProjects" :key="project.id" :index="index" :project="project" />
    </ul>
  </section>
</template>

<style lang="css" scoped></style>
